import dataApplicationsContext from "../../../context/dataApplicationsContext"
import { useContext, useRef } from 'react';
import UserGoBack from "../../user/UserGoBack";
import RightPartContent from "../RightPartContent";
import ArticleUtile from "../ArticleUtile";
import TagsAnchorContainer from "../TagsAnchorContainer";
import { useSectionRefs } from "../../../hooks/useSectionRefs";

const HelpTopicQuoiComment = () => {
  const { windowWidth } = useContext(dataApplicationsContext);
  const { anchorsParts, topic, isLoading, LoadingComponent } = useSectionRefs();
  if (isLoading) return <LoadingComponent />;
  
  const isSmallDevise = windowWidth < 900;  

  const goBackLinks = [
    { label: 'Accueil', link: '/'},
    { label: 'Tous les sujets', link: '/topics'},
    { label: 'À propos de Wodzone', link: '/topics/about'},
    { label: 'Fonctionnement de Wodzone', link: '/topics/about/fonctionnement'},
    { label: topic.title, link: topic.link},
  ]


  return (
    <div className="user-setting-container help">
      <UserGoBack
        goBackLinks={goBackLinks} isSmallDevise={isSmallDevise} guideInfo={topic.slug} titleClass='mb-0 w-help-title'
      />
      <div className="help-content-container mt-16">
        <div className="help-content-flex mb-80">
          <div className="help-left-part">
            <p className="help-text">
              Vous pouvez organiser des tout type de compétition de CrossFit, n'importe où en France ou en ligne, afin qu'ils puissent challenger leurs fitness.
            </p>
            <TagsAnchorContainer parts={anchorsParts} legend='Dans cet article'/>
            <div className="article-container mt-40" ref={anchorsParts[0].ref}>
              <p className="help-title-part">{anchorsParts[0].content}</p>
              <p className="help-text">
                Wodzone a vu le jour en 2024 dans une salle de CrossFit. Lors de sa première participation à une compétition, un designer, peu convaincu par l'outil disponible pour suivre l'événement, 
                a décidé de créer sa propre solution, unique et ergonomique. Par la suite, un autre développeur, non moins talentueux à rejoins le projet. 
                Depuis, des centaines d'athlètes ont créé gratuitement des<a target='_blank' className="link" href="/topics/compte/1">comptes Wodzone</a>
                pour explorer le monde des compétitions de CrossFit sous un nouvel angle.
              </p>
            </div>
            <div className="article-container mt-56" ref={anchorsParts[1].ref}>
              <p className="help-title-part mb-8">{anchorsParts[1].content}</p>
              <p className="help-text">
                Qu'il s'agisse de compétitions internes à votre box ou d'événements ouverts à toute la France, les organisateurs s'efforcent de créer une expérience 
                inoubliable. Que ce soit pour vous surpasser ou vous mesurer à d'autres athlètes, des centaines d'arènes uniques vous attendent pour relever le défi.
              </p>
            </div>
            <div className="article-container mt-56" ref={anchorsParts[2].ref}>
              <p className="help-title-part mb-8">{anchorsParts[2].content}</p>
              <p className="help-text">
                Nous souhaitons que votre expérience sur Wodzone soit facile et agréable. Voici comment nous contribuons à créer un espace où vous pouvez vous sentir 
                en sécurité :
              </p>
              <ul>
                <li className="pl-8 mb-16"><p className="help-text">Vérification des profils et des annonces</p></li>
                <li className="pl-8 mb-16"><p className="help-text">Plateforme sécurisée pour recevoir et envoyer des paiements</p></li>
              </ul>
              <p className="help-text"><a target='_blank' className="link" href="#">En savoir plus sur notre engagement pour votre sécurité</a></p>
            </div>
            <div className="article-container mt-56" ref={anchorsParts[3].ref}>
              <p className="help-title-part mb-8">{anchorsParts[3].content}</p>
              <p className="help-text">
                Vous avez des questions ? Trouvez des réponses dans le<a target='_blank' className="link" href="/">Centre d'aide.</a> 
                Vous pouvez obtenir des informations sur la<a target='_blank' className="link" href="#">recherche d'une compétition,</a> 
                le<a target='_blank' className="link" href="#">paiement de votre réservation</a>et plus encore.
              </p>
              <p className="help-text">
                Les athlètes et organisateurs sur Wodzone sont toujours très réactifs, et nous aussi. Notre équipe d'assistance à la communauté peut vous venir en aide 24h/24, 
                7j/7. Besoin d'aide pour effectuer une nouvelle réservation ou autre chose ? N'hésitez pas à nous <a target='_blank' className="link" href={`${process.env.REACT_APP_FRONT_URL_APP}/contact`}>contacter</a>
              </p>
            </div>
            <ArticleUtile id_topic={topic.id_topic}/>
          </div>
          <RightPartContent />
        </div>
      </div>
    </div>
  )
}

export default HelpTopicQuoiComment